<script>
export default {
    name: 'IconStage',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-stage"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 12V8h40v4h-4v32h-5.125L51.5 56H48l-8.625-12H33v8h-2v-8h-6.375L16 56h-3.5l8.625-12H16V12h-4zm18 10h14v2H30v-2zm-10-3h6v5h-6v-5zm0 9h24v2H20v-2zm0 6h24v2H20v-2z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
